@if (action() === 'modal') {
  <button (click)="openModal()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </button>
} @else {
  <a routerLink="/add-company">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </a>
}

<ng-template #content>
  <sd-icon [class]="'icon-size-' + size()" [type]="iconTypes.PLUS"></sd-icon>
  <span class="btn-text">добавить компанию</span>
</ng-template>
